import { ManualCodeEntry } from '@/components/manual-code-entry/component';
import { Scanner } from '@/components/scanner';
import { MobileContainer } from '@/components/workflow/mobile-container';
import { MobileHeader } from '@/components/workflow/mobile-header';
import { Button, Flex } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { useBagAuditContext } from '../hook';

export const BagAuditScanPage = () => {
	const { handleScan, showManualCodeEntry, setShowManualCodeEntry, scanError } =
		useBagAuditContext();
	const [code, setCode] = useState('');
	const [isSubmitting, setIsSubmitting] = useState(false);
	const navigate = useNavigate();

	const handleManualSubmit = async () => {
		if (!code.trim()) return;

		setIsSubmitting(true);
		try {
			await handleScan(code.trim());
			setCode('');
			setShowManualCodeEntry(false);
		} finally {
			setIsSubmitting(false);
		}
	};

	const handleClose = () => {
		setCode('');
		setShowManualCodeEntry(false);
	};

	return (
		<MobileContainer
			header={<MobileHeader title="Bag Audit" onClose={() => navigate({ to: '/facility/home' })} />}
		>
			<Scanner onScan={handleScan} />
			{scanError && (
				<div
					style={{
						padding: '16px',
						backgroundColor: '#fee',
						color: '#c00',
						borderRadius: '4px',
						margin: '16px',
						position: 'fixed',
						bottom: 60,
					}}
				>
					Invalid bag state. Please scan a different bag or check the bag status.
				</div>
			)}
			<ManualCodeEntry
				value={code}
				setValue={setCode}
				open={showManualCodeEntry}
				instructions="Please enter the code found on the bag."
				onClose={handleClose}
				actions={({ onClose }) => {
					return (
						<Flex>
							<Button variant="filled" bg="grey" c="white" fullWidth onClick={onClose}>
								Cancel
							</Button>
							<Button
								variant="filled"
								fullWidth
								onClick={handleManualSubmit}
								disabled={!code.trim() || isSubmitting}
								loading={isSubmitting}
							>
								Submit
							</Button>
						</Flex>
					);
				}}
			/>
		</MobileContainer>
	);
};
